/**
 * Arquivo de Configuração de Textos - White Label
 * 
 * Este arquivo centraliza todos os textos estáticos usados no projeto.
 * Para personalizar para um novo cliente, basta alterar os valores aqui.
 */

const texts = {
  // ============ INFORMAÇÕES DA EMPRESA ============
  company: {
    name: 'Oni Telecom',
    slogan: 'Conectando você ao futuro',
    description: 'A Oni Telecom é uma empresa de telecomunicações inscrita no CNPJ 000.111.333/000 com licença SCM da Anatel.',
    copyright: '© 2026 Oni Telecom. Todos os direitos reservados.',
  },

  // ============ HEADER ============
  header: {
    topBar: {
      centralAssinante: 'Central do Assinante',
    },
    topNav: {
      discover: 'Descubra',
      empresas: 'Para Empresas',
      condominios: 'Condomínios',
      tecnologia: 'Tecnologia 5G',
    },
    mainNav: {
      planos: 'Planos',
      entretenimento: 'Entretenimento',
      internet: 'Internet',
      telefonia: 'Telefonia',
    },
    mobileNav: {
      inicio: 'Início',
      planos: 'Planos',
      entretenimento: 'Entretenimento',
      internet: 'Internet',
      telefonia: 'Telefonia',
    },
    buttons: {
      centralAssinante: 'Central do Assinante',
      pagarFatura: 'Pague sua Fatura aqui!',
      assineAgora: 'Assine Agora!',
    },
  },

  // ============ FOOTER ============
  footer: {
    location: {
      label: 'Você está em:',
      city: 'Brejinho - PE',
    },
    socialMedia: {
      label: 'Siga-nos nas redes sociais',
    },
    downloadApp: 'Baixe o app Oni Play agora!',
    companyInfo: {
      description: 'A Oni Telecom é uma empresa de telecomunicações que oferece internet de alta velocidade, telefonia e entretenimento com qualidade e inovação.',
    },
    sections: {
      institucional: 'Institucional',
      planosServicos: 'Planos e serviços',
      contato: 'Contato',
    },
    columns: {
      institucional: {
        title: 'Institucional',
        quemSomos: 'Quem somos?',
        porQue: 'Por que Oni?',
        blog: 'Blog',
        contratos: 'Contratos',
      },
      planos: {
        title: 'Planos e Serviços',
        combos: 'Combos',
        internet: 'Internet',
        oniPlay: 'Oni Play',
        linhaMovel: 'Linha Móvel',
      },
      contato: {
        title: 'Contato',
        atendimento: 'Atendimento',
        ouvidoria: 'Ouvidoria',
        faq: 'Perguntas Frequentes',
      },
      app: {
        title: 'Baixe nosso App',
      },
    },
    buttons: {
      centralAssinante: 'Central do assinante',
      recargaCelular: 'Recarga de celular',
      assineAgora: 'Assine agora',
    },
  },

  // ============ BANNER ============
  banner: {
    title: 'Soluções Oni Telecom para Empresas',
    subtitle: 'Conectividade completa e segurança para impulsionar o seu negócio com tecnologia de ponta',
    buttonText: 'Conheça Nossos Serviços',
  },

  // ============ INTRODUÇÃO ============
  introducao: {
    title: 'Bem-vindo à Oni Telecom',
    subtitle: 'Sua melhor escolha em internet, telefonia e entretenimento',
    description: 'Oferecemos soluções completas de telecomunicações com a melhor tecnologia do mercado.',
  },

  // ============ CONTATO ============
  contato: {
    title: 'Precisa de Ajuda? Entre em Contato!',
    whatsapp: {
      label: 'Tire suas dúvidas agora!',
    },
    phone: {
      label: 'Chamada Gratuita',
    },
  },

  // ============ SERVIÇOS ============
  servicos: {
    title: 'Nossos Serviços',
    buttonText: 'Saiba Mais',
  },

  // ============ SERVIÇOS ESSENCIAIS ============
  servicosEssenciais: {
    title: 'Soluções rápidas ao seu alcance',
  },

  // ============ TELEFONIA BANNER ============
  telefoniaBanner: {
    card1: {
      titulo: 'Recarga Rápida e Fácil',
      descricao: 'Mantenha-se conectado com recargas instantâneas. Recarregue seu número Oni ou surpreenda alguém especial com créditos extras!',
      botao: 'Recarregar Agora',
    },
    card2: {
      titulo: 'Novo na Oni?',
      descricao: 'Descubra planos flexíveis e uma cobertura excepcional. Junte-se à rede que entende suas necessidades.',
      botao: 'Conheça Nossos Planos',
    },
  },

  // ============ PÁGINA INICIAL ============
  home: {
    banner: {
      title: 'Soluções Oni Telecom para Empresas',
      subtitle: 'Conectividade completa e segurança para impulsionar o seu negócio com tecnologia de ponta',
      button: 'Conheça Nossos Serviços',
    },
    servicosEssenciais: {
      title: 'Soluções rápidas ao seu alcance',
      cards: [
        { text: 'Consulte sua fatura' },
        { text: 'Tire suas dúvidas' },
        { text: 'Fale conosco' },
        { text: 'Faça uma recarga' },
      ],
    },
    ofertas: {
      title: 'Turbine sua conexão',
      subtitle: 'Planos de internet ultrarrápida com benefícios exclusivos para sua empresa!',
      toggleText: 'Ver todos os benefícios',
      header: 'Para sua empresa',
      buttons: {
        escolher: 'Escolher Plano',
        details: 'Ver Detalhes',
      },
      benefits: {
        escolhaAplicativos: 'Escolha 2 aplicativos',
        velocidade: 'Velocidade',
        porMes: 'por mês',
      },
    },
    contato: {
      title: 'Precisa de Ajuda? Entre em Contato!',
      whatsapp: 'Tire suas dúvidas agora!',
      telefone: 'Chamada Gratuita',
    },
  },

  // ============ FAQ ============
  faq: {
    title: 'Perguntas Frequentes',
    subtitle: 'Encontre respostas para as dúvidas mais comuns',
    search: {
      placeholder: 'Buscar perguntas...',
      noResults: 'Nenhuma pergunta encontrada',
      searching: 'Buscando...',
    },
    categories: {
      internet: 'Internet Fibra',
      oniplay: 'OniPlay',
      oni5g: 'Oni 4G/5G',
      dados: 'Alteração de Dados',
      planos: 'Alteração de Plano',
      indicacao: 'Indique um Amigo',
      seguranca: 'Segurança',
      aplicativos: 'Aplicativos',
      suporte: 'Suporte Técnico',
    },
  },

  // ============ PLANOS ============
  planos: {
    title: 'Nossos Planos',
    subtitle: 'Escolha o plano perfeito para você',
    velocidade: 'Mega',
    porMes: '/mês',
    contratar: 'Contratar',
    saibaMais: 'Saiba Mais',
    beneficios: 'Benefícios inclusos',
  },

  // ============ INTERNET ============
  internet: {
    title: 'Internet de Alta Velocidade',
    subtitle: 'Fibra óptica até sua casa',
    beneficios: {
      velocidade: 'Velocidade garantida',
      estabilidade: 'Conexão estável',
      suporte: 'Suporte 24/7',
      instalacao: 'Instalação grátis',
    },
  },

  // ============ ENTRETENIMENTO ============
  entretenimento: {
    title: 'Entretenimento sem Limites',
    subtitle: 'Streaming, jogos e muito mais',
    apps: {
      onigo: 'Oni Go',
      skyPlus: 'Sky+',
      max: 'Max',
      playkids: 'Playkids',
      deezer: 'Deezer',
      estudaMais: 'Estuda+',
      hub: 'Hub',
      kaspersky: 'Kaspersky',
      leitura360: 'Leitura 360',
    },
  },

  // ============ EMPRESAS ============
  empresas: {
    title: 'Soluções para Empresas',
    subtitle: 'Conectividade e segurança para o seu negócio',
    beneficios: {
      velocidade: 'Alta velocidade',
      suporte: 'Suporte dedicado',
      seguranca: 'Máxima segurança',
      escalabilidade: 'Escalável',
    },
  },

  // ============ CARRINHO ============
  carrinho: {
    title: 'Seu Carrinho',
    vazio: 'Seu carrinho está vazio',
    continuar: 'Continuar Comprando',
    finalizar: 'Finalizar Pedido',
    remover: 'Remover',
    total: 'Total',
    subtotal: 'Subtotal',
    desconto: 'Desconto',
    quantidade: 'Quantidade',
    tabs: {
      planos: 'Planos',
      internet: 'Internet',
      telefonia: 'Telefonia',
      entretenimento: 'Entretenimento',
    },
  },

  // ============ APP EXCLUSIVO ============
  appExclusivo: {
    banner: 'Seu App Exclusivo de entretenimento na Oni.',
    destaque: 'App Exclusivo',
    titulo: 'O melhor da TV pra você curtir a qualquer hora e em qualquer lugar.',
    controles: {
      play: 'Dê Play,',
      pause: 'Pause,',
      grave: 'Grave e Volte',
      quando: 'quando quiser.',
    },
  },

  // ============ CARDS ENTRETENIMENTO ============
  cardsEntretenimento: {
    categorias: {
      streamingMusica: 'STREAMING E MÚSICA',
      educacao: 'EDUCAÇÃO',
      segurancaDigital: 'SEGURANÇA DIGITAL',
      saudeBemEstar: 'SAÚDE E BEM-ESTAR',
    },
    buttons: {
      saibaMais: 'Saiba mais',
      consultar: 'Consultar condições',
    },
  },

  // ============ DEPOIMENTOS ============
  depoimentos: {
    titulo: 'O Que Nossos Clientes Dizem',
  },

  // ============ DIVISOR SEÇÃO ============
  divisorSecao: {
    titulo: 'Transforme sua infraestrutura de comunicação com a Oni Telecom',
  },

  // ============ FAIXA PLANOS ============
  faixaPlanos: {
    texto: 'Quer um plano diferente?',
    subtexto: 'Nós ajudamos a montar o plano ideal para você',
    botao: 'Montar Meu Plano',
  },

  // ============ HELP SECTION ============
  helpSection: {
    titulo: 'Precisa de',
    tituloDestaque: 'ajuda?',
    subtitulo: 'Estamos aqui para',
    subtituloDestaque: 'você!',
    descricao: 'Descubra como podemos tornar sua experiência ainda mais incrível. Escolha uma opção abaixo e vamos começar!',
  },

  // ============ INFINITE POSSIBILITIES ============
  infinitePossibilities: {
    titulo: 'Possibilidades infinitas de soluções e entretenimento para sua vida.',
  },

  // ============ LOCATION SELECTOR ============
  locationSelector: {
    titulo: 'Onde você está?',
    subtitulo: 'Selecione seu estado e cidade',
    estado: 'Estado',
    cidade: 'Cidade',
    buscar: 'Buscar Planos',
    detectar: 'Detectar Minha Localização',
    selecioneEstado: 'Selecione um estado',
    selecioneCidade: 'Selecione uma cidade',
    carregando: 'Detectando sua localização...',
    erroGeo: 'Não foi possível obter sua localização. Por favor, selecione manualmente.',
    cidadeIndisponivel: 'Desculpe, a Oni ainda não está disponível na sua cidade. Por favor, selecione uma das cidades disponíveis.',
    geoNaoSuportado: 'Geolocalização não é suportada pelo seu navegador. Por favor, selecione manualmente.',
  },

  // ============ PLANO CONTROLE ============
  planoControle: {
    titulo: 'Plano Controle',
    subtitulo: 'com benefícios exclusivos',
    beneficios: {
      ligacoes: 'Ligações',
      ilimitadas: 'ilimitadas',
      mais: '+',
      internet: 'internet',
      movel: 'móvel',
      apartir: 'a partir de',
    },
    preco: '17,90',
    botao: 'Contrate Agora!',
    secaoInfo: {
      titulo: 'Aqui, seus dados de internet nunca expiram.',
      descricao: 'Os dados que você não usar, na renovação mensal do seu plano, eles acumulam pra você se manter conectado o tempo todo.',
      rodape: '* Benefício para usuários com recorrência automática no cartão de crédito.',
    },
  },

  // ============ POR QUE ESCOLHER ============
  porQueEscolher: {
    titulo: 'Por Que Escolher a Oni Telecom?',
  },

  // ============ QUEM SOMOS ============
  quemSomos: {
    titulo: 'MUITO PRAZER!',
    subtitulo: 'SOMOS A ONI TELECOM.',
    paragrafo1: 'Uma empresa paraibana com mais de 10 anos de excelência no mercado de telecomunicações. Atuamos com redes ópticas e digitais, conectando mais de 20.000 usuários nos estados da Paraíba, Pernambuco e Rio Grande do Norte.',
    paragrafo2: 'Oferecemos soluções tecnológicas modernas que conectam pessoas e empresas a um universo de infinitas possibilidades em todo lugar e o tempo todo.',
    botao: 'Entre em Contato',
    oferecemos: {
      titulo: 'O que oferecemos?',
      items: [
        'Internet de alta velocidade com fibra óptica.',
        'Atendimento personalizado e suporte técnico 24/7.',
        'Soluções corporativas sob medida.',
        'Rede confiável e estável para home office e negócios.',
      ],
    },
    diferenciais: {
      titulo: 'Nossos diferenciais',
      items: [
        'Equipamentos de última geração.',
        'Mais de 20.000 clientes satisfeitos.',
        'Presença consolidada em 3 estados.',
        'Compromisso com inovação e conectividade.',
      ],
    },
  },

  // ============ FORMULÁRIOS ============
  forms: {
    labels: {
      nome: 'Nome',
      email: 'E-mail',
      telefone: 'Telefone',
      cpf: 'CPF',
      cep: 'CEP',
      endereco: 'Endereço',
      numero: 'Número',
      complemento: 'Complemento',
      bairro: 'Bairro',
      cidade: 'Cidade',
      estado: 'Estado',
      senha: 'Senha',
      confirmarSenha: 'Confirmar Senha',
      mensagem: 'Mensagem',
    },
    placeholders: {
      nome: 'Digite seu nome completo',
      email: 'seu@email.com',
      telefone: '(00) 00000-0000',
      cpf: '000.000.000-00',
      cep: '00000-000',
      mensagem: 'Digite sua mensagem',
    },
    buttons: {
      enviar: 'Enviar',
      cancelar: 'Cancelar',
      salvar: 'Salvar',
      voltar: 'Voltar',
      proximo: 'Próximo',
      concluir: 'Concluir',
    },
    validation: {
      required: 'Este campo é obrigatório',
      email: 'E-mail inválido',
      cpf: 'CPF inválido',
      telefone: 'Telefone inválido',
      senhaFraca: 'Senha muito fraca',
      senhasNaoCoincidem: 'As senhas não coincidem',
    },
  },

  // ============ MENSAGENS DO SISTEMA ============
  messages: {
    success: {
      cadastro: 'Cadastro realizado com sucesso!',
      atualizado: 'Dados atualizados com sucesso!',
      enviado: 'Mensagem enviada com sucesso!',
      adicionado: 'Item adicionado ao carrinho!',
      removido: 'Item removido do carrinho!',
    },
    error: {
      geral: 'Ocorreu um erro. Tente novamente.',
      conexao: 'Erro de conexão. Verifique sua internet.',
      naoEncontrado: 'Item não encontrado',
      semPermissao: 'Você não tem permissão para esta ação',
    },
    loading: {
      carregando: 'Carregando...',
      processando: 'Processando...',
      aguarde: 'Aguarde...',
    },
  },

  // ============ BOTÕES GENÉRICOS ============
  buttons: {
    saibaMais: 'Saiba Mais',
    contratar: 'Contratar',
    assinar: 'Assinar',
    comprar: 'Comprar',
    adicionar: 'Adicionar',
    remover: 'Remover',
    editar: 'Editar',
    excluir: 'Excluir',
    confirmar: 'Confirmar',
    cancelar: 'Cancelar',
    fechar: 'Fechar',
    voltar: 'Voltar',
    proximo: 'Próximo',
    anterior: 'Anterior',
    verMais: 'Ver Mais',
    verMenos: 'Ver Menos',
  },

  // ============ DIAS DA SEMANA E MESES ============
  date: {
    days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    months: [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ],
    monthsShort: [
      'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
      'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
    ],
  },
};

/**
 * Função auxiliar para obter um texto
 * Uso: getText('company.name')
 */
export const getText = (path, defaultValue = '') => {
  const keys = path.split('.');
  let value = texts;
  
  for (const key of keys) {
    value = value[key];
    if (value === undefined) {
      console.warn(`Texto não encontrado: ${path}`);
      return defaultValue;
    }
  }
  
  return value;
};

/**
 * Função para interpolação de textos
 * Uso: interpolate('Olá, {name}!', { name: 'João' }) => 'Olá, João!'
 */
export const interpolate = (text, variables = {}) => {
  return text.replace(/{(\w+)}/g, (match, key) => {
    return variables[key] !== undefined ? variables[key] : match;
  });
};

export default texts;
